import React, {useEffect, useState} from "react";
import ReactWOW from "react-wow";
import "./../css/contact.scss";
import { Container, Row, Col } from "react-bootstrap";
import FormFormik from "./../component/FormikLead";
import axios from "axios";

function ContactPage() {

  const [call, setCall] = useState(false);
  const [write, setWrite] = useState(false);
  const [join, setJoin] = useState(false);

  const getPageInfo = async () => {
    await axios
        .get("/page/contact")
        .then(({ data }) => {
          const page = data;
          // 404
          if (!page) {
            props.history.push("/404");
          } else {
            setCall(page.call);
            setWrite(page.write);
            setJoin(page.join);

          }
        });
  }

  useEffect(getPageInfo, []);

  return (
      <div>
        <Container className="pl-0 pr-0">
          <div className="wrapBG">
            <Row className="mt80px mb80px">
              <Col xl="12" lg="12" md="12" sm="12">
                <ReactWOW delay="1s" animation="slideInUp">
                  <h2 className="titleH2 mt-5 animate__animated animate__delay-1s animate__slideInUp">
                    Будемо на зв’язку
                  </h2>
                </ReactWOW>
              </Col>
            </Row>
            <Row className="align-items-center firstBlockRow firstBlockRowContact">
              <Col xl="6" lg="6" md="12" sm="12" className="flexTop">
                <div className="wrapContactItems">
                  <div className="contactItemBig">
                    Телефонуйте
                  </div>
                  <div className="contactItemSmall contactItemSmallIconCall">
                    <a href={`tel:${call}`}>{call}</a>
                  </div>
                </div>
                <div className="wrapContactItems">
                  <div className="contactItemBig">
                    Напишіть
                  </div>
                  <div className="contactItemSmall contactItemSmallIconEmail">
                    <a href={`mailto:${write}`}>{write}</a>
                  </div>
                </div>
                <div className="wrapContactItems">
                  <div className="contactItemBig">
                    Приєднуйтесь
                  </div>
                  <div className="contactItemSmall contactItemSmallIconLinkedin">
                    <a href={join} target="_blank" rel="noopener noreferrer">LinkedIn</a>
                  </div>
                </div>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12" className="flexTop">
                <div className="contacts-wrap-form">
                  <FormFormik />
                </div>
              </Col>
            </Row>
            <Row className="mt80px mb40px ml10px mr10px">
              <Col xl="12" lg="12" md="12" sm="12">
                <p className="p3Contact">
                  Gulliver Tower B
                  <br /> Спортивна площа, 1, Київ, Україна, 02000
                </p>
                <div className="wrapImgMap">
                  {/* <img src={imgMap} alt="" className="imgMap" /> */}
                  <iframe src="https://www.google.com/maps?q=50.4385286,30.5233496&z=17&output=embed" width="100%" height="450" frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0" title="myFrame"></iframe>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

  );
}

export default ContactPage;
